import { useContext } from "react"
import { Route, Routes, useNavigate } from "react-router-dom"
import { AuthContext, useAuthSession } from "../context/AuthContext"
import routes from "./config"
// import { useNapNegocios } from "context";
// import Page401 from "pages/Errors/Page401";

const ConfigRoutes = () => {
  const { dataUser } = useAuthSession()
  const roles = [ "superadmin" ]

  return (
    <Routes>
      {routes.map( ( e, ind ) => {
        const { path, element: Component, children, isPrivate } = e
        return isPrivate ? (
          <Route path={path} element={<Component />} exact={true} key={ind}>
            {children.map( ( el, indx ) => {
              const { path: ruta, element: Element, roles: fixedRoles } = el
              let flag = false
              fixedRoles.forEach( ( el ) => {
                if ( roles.includes( el ) ) flag = true
              } )
              return (
                <Route
                  path={ruta}
                  element={
                    flag ? (
                      <Element />
                    ) : (
                      <div>
                        <h1>no esta autohirzado</h1>
                      </div>
                    )
                  }
                  // element={<Element />}
                  exact={true}
                  key={indx}
                />
              )
            } )}
          </Route>
        ) : Boolean( children ) ? (
          <Route path={path} element={<Component />} exact={true} key={ind}>
            {children.map( ( el, indx ) => {
              const { path: ruta, element: Element } = el
              return (
                <Route
                  path={ruta}
                  element={<Element />}
                  exact={true}
                  key={indx}
                />
              )
            } )}
          </Route>
        ) : (
          <Route path={path} element={<Component />} exact={true} key={ind} />
        )
      } )}
    </Routes>
  )
}

export default ConfigRoutes
